export async function submitInquiry(formType, data) {
  const endpoint = process.env.REACT_APP_FORM_ENDPOINT;

  if (endpoint) {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        formType,
        ...data,
        submittedAt: new Date().toISOString(),
        source: window.location.pathname,
      }),
    });

    if (!response.ok) {
      throw new Error("Form submission failed");
    }

    return { method: "api" };
  }

  const recipient = process.env.REACT_APP_FORM_EMAIL || "info@southasiaconsultancy.com";
  const subject = encodeURIComponent(`${formType} — South Asia Consultancy`);
  const body = encodeURIComponent(
    Object.entries(data)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n")
  );

  window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
  return { method: "mailto" };
}
